import { useState } from 'react';
import { css } from '@emotion/react';
import { Headers } from '@frontend/header';
import { Page } from '@frontend/page';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { VoicemailHeader } from '../components/voicemails/voicemail-header';
import { VoicemailPage } from '../components/voicemails/voicemails-multi.component';

export const Voicemails = () => {
  const [selectedTimeRange, setSelectedTimeRange] = useState<string>('');

  return (
    <Page css={styles}>
      <Page.Header>
        <Headers.Root
          css={css`
            padding: 0;
          `}
        >
          <Headers.RouterBreadcrumb />
          <VoicemailHeader selectedTimeRange={selectedTimeRange} setSelectedTimeRange={setSelectedTimeRange} />
        </Headers.Root>
      </Page.Header>
      <Page.Body>
        <VoicemailPage setSelectedTimerange={setSelectedTimeRange} />
      </Page.Body>
    </Page>
  );
};

const styles = css`
  max-width: 100%;
  overflow: auto;
  height: 100%;

  @container main-content (max-width: ${breakpoints.xsmall.max}px) {
    padding: 0;

    .page-header {
      padding: ${theme.spacing(2, 2, 0, 2)};
      margin: 0;
    }
  }
`;
